<div class="container select-none">
  <div class="grid grid-cols-1 gap-6 items-stretch" [ngClass]="hasFAQ() ? 'lg:grid-cols-3 md:grid-cols-3' : 'lg:grid-cols-2 md:grid-cols-2'">

    <mat-card class="flex flex-col gap-3 items-start justify-between rounded-md bg-mat-ef-revolution-grey-500 h-full w-full">
      <div class="w-full">
        <div
          class="w-full flex font-efSans text-xl font-black text-mat-ef-revolution-primary-500 mb-1"
        >
          <T
            str="Customer portal support"
            key="customerPortal.customer-portal.support.title"
            tags="customer-portal, 3.1"
          ></T>
        </div>
        <!-- prettier-ignore -->
        <div
          class="text-sm text-efSans text-mat-ef-revolution-primary-500"
          [innerHTML]="getTranslation()"
        ></div>
      </div>

      <div
        class="btn-rounded-btn lg:w-fit"
        (click)="
          openMailClient();
          sendContentModulesCTAData(
            'customerPortal.customer-portal.support.contact'
          )
        "
      >
        <T
          str="Contact us"
          key="customerPortal.customer-portal.support.contact"
          tags="customer-portal, 3.1"
        ></T>
      </div>
    </mat-card>

    @if (hasSupportVehicleCard()) {
      <customer-portal-app-support-vehicle-card class="block h-full w-full"></customer-portal-app-support-vehicle-card>
    }
    @if (hasFAQ()) {
      <customer-portal-app-faq-card class="block h-full w-full"></customer-portal-app-faq-card>
    }
  </div>
</div>
